module.exports = __webpack_public_path__ + "img/strip-5.2a464c96.svg";